import React from 'react';
import { useTranslation } from 'react-i18next';
import DwFormField from '@ui/formfield/DwFormField';
const BookAnAppointmentReasonMessage = (props) => {
    const { t } = useTranslation();
    const { formdef, values } = props;
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "row" },
            React.createElement("div", { className: "col-24" },
                React.createElement(DwFormField, { def: formdef, name: "messageforstore", type: "text", overridePlaceholder: t('bookanappointment.reasonmessage.placeholder') })))));
};
export default BookAnAppointmentReasonMessage;
